/**
 * New User Banner Component
 * Shows "You have X new users added to Navigator" banner
 * Clicking banner filters the table to show only new users
 */

import React from 'react';
import { Platform, View, Text, TouchableOpacity, StyleSheet } from 'react-native';
import { InfoIcon } from '../../components/AdminIcons';
import { AdminColors } from '../../constants/adminColors';
import FontFamily from '../../../../constants/fonts';
import { useTheme } from '../../../../theme/useTheme';

interface NewUserBannerProps {
  count: number;
  onPress: () => void;
  onDismiss?: () => void;
}

const NewUserBanner: React.FC<NewUserBannerProps> = ({ count, onPress, onDismiss }) => {
  const { colors, resolvedTheme } = useTheme();
  const isDark = resolvedTheme === 'dark' && Platform.OS !== 'web';

  if (count === 0) return null;

  return (
    <TouchableOpacity
      style={[
        styles.banner,
        isDark && { backgroundColor: colors.statusBackground.info, borderLeftColor: colors.brand.primary },
      ]}
      onPress={onPress}
      activeOpacity={0.8}
    >
      <View style={styles.iconWrapper}>
        <InfoIcon size={18} color={isDark ? colors.brand.primary : '#1E5A7A'} />
      </View>
      <Text style={[styles.text, isDark && { color: colors.brand.primary }]}>
        You have <Text style={[styles.bold, isDark && { color: colors.brand.primary }]}>{count} new user{count !== 1 ? 's' : ''}</Text> added to Navigator
      </Text>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  banner: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 16,
    paddingVertical: 10,
    backgroundColor: AdminColors.blue75,
    borderLeftWidth: 3,
    borderLeftColor: AdminColors.blue700,
    borderRadius: 8,
    marginBottom: 14,
    gap: 10,
  },
  iconWrapper: {
    flexShrink: 0,
  },
  text: {
    flex: 1,
    fontSize: 13,
    lineHeight: 18,
    color: '#1E5A7A',
    fontFamily: FontFamily.medium,
  },
  bold: {
    fontWeight: '600',
    fontFamily: FontFamily.bold,
  },
  clickText: {
    fontSize: 12,
    fontWeight: '600',
    color: AdminColors.blue700,
    fontFamily: FontFamily.bold,
  },
});

export default NewUserBanner;
